import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Progress API service — manages per-user progress overlays for shared courses
 */
export const ProgressApi = {
  /**
   * Get current user's progress for an assignment
   * @param {string|number} assignmentId
   * @returns {Promise<Response>} UserAssignmentProgressDTO
   */
  getAssignmentProgress: async (assignmentId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/assignments/${assignmentId}/progress`, {
      method: 'GET',
    });
  },

  /**
   * Update current user's progress for an assignment
   * @param {string|number} assignmentId
   * @param {Object} body - { completed, notes, personalDueDatetime }
   * @returns {Promise<Response>} Updated UserAssignmentProgressDTO
   */
  updateAssignmentProgress: async (assignmentId, body) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/assignments/${assignmentId}/progress`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  },

  /**
   * Get current user's progress for an event
   * @param {string|number} eventId
   * @returns {Promise<Response>} UserEventProgressDTO
   */
  getEventProgress: async (eventId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/events/${eventId}/progress`, {
      method: 'GET',
    });
  },

  /**
   * Update current user's progress for an event
   * @param {string|number} eventId
   * @param {Object} body - { completed, notes }
   * @returns {Promise<Response>} Updated UserEventProgressDTO
   */
  updateEventProgress: async (eventId, body) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/events/${eventId}/progress`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  },

  /**
   * Get all progress for current user in an endeavor (assignments + events)
   * @param {string|number} endeavorId
   * @returns {Promise<Response>} { assignments: [...], events: [...] }
   */
  getEndeavorProgress: async (endeavorId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavors/${endeavorId}/progress`, {
      method: 'GET',
    });
  },

  /**
   * Get analytics for all students in an endeavor (owner/professor only)
   * @param {string|number} endeavorId
   * @returns {Promise<Response>} Analytics data with per-student progress
   */
  getEndeavorAnalytics: async (endeavorId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavors/${endeavorId}/analytics`, {
      method: 'GET',
    });
  },
};
